var map = {
	"./1-1.svg": "bd6f",
	"./1-2.svg": "0150",
	"./1-3.svg": "d9b2",
	"./1-4.svg": "76d1",
	"./1-5.svg": "1e06",
	"./2-1.svg": "b559",
	"./2-2.svg": "e3a9",
	"./2-3.svg": "bdf4",
	"./2-4.svg": "7038",
	"./2-5.svg": "a804",
	"./3-1.svg": "fabd",
	"./3-2.svg": "8bb0",
	"./3-3.svg": "1997",
	"./3-4.svg": "c7e9",
	"./3-5.svg": "bf41",
	"./4-1.svg": "3a42",
	"./4-2.svg": "d614",
	"./4-3.svg": "6a22",
	"./4-4.svg": "e5f4",
	"./4-5.svg": "c4bb",
	"./5-1.svg": "d5b6",
	"./5-2.svg": "5dfe",
	"./5-3.svg": "1790",
	"./5-4.svg": "c0fc6",
	"./5-5.svg": "e0fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f11";